import React from "react";

import clsx from "clsx";

import {
  type Annotation,
  type NewAnnotation,
} from "@features/custom-annotations";
import {
  ConfirmActionButton,
  PrimaryButton,
  TertiaryButton,
} from "@shared/buttons";
import Spinner from "@shared/spinner";

interface Props {
  className?: string;
  currentAnnotation: Annotation | NewAnnotation;
  clearCurrentAnnotation: () => void;
  isSubmitting: boolean;
  deleteAnnotation: (id: string) => Promise<void>;
  isAnnotationsLoading: boolean;
}

export const AnnotationFormControl = ({
  className,
  currentAnnotation,
  clearCurrentAnnotation,
  isSubmitting,
  deleteAnnotation,
  isAnnotationsLoading,
}: Props) => {
  const isEdit = "id" in currentAnnotation;

  return (
    <div className={clsx(className, "flex items-center justify-between")}>
      <div className="flex items-center gap-2">
        <PrimaryButton
          isDisabled={isAnnotationsLoading || isSubmitting}
          type="submit"
          className="font-bold flex items-center gap-2"
        >
          {isSubmitting && <Spinner colorClassname="text-white-400" />}
          SAVE
        </PrimaryButton>
        {isEdit && (
          <ConfirmActionButton
            title="Are you sure you want to delete this note?"
            onConfirm={async () => {
              if (!("id" in currentAnnotation)) {
                return;
              }

              await deleteAnnotation(currentAnnotation.id);
              clearCurrentAnnotation();
            }}
            actionButton={
              <TertiaryButton
                className="danger-button font-bold text-white"
                isDisabled={isAnnotationsLoading}
              >
                DELETE
              </TertiaryButton>
            }
          />
        )}
      </div>
      <TertiaryButton
        isDisabled={isAnnotationsLoading || isSubmitting}
        className="font-bold"
        onClick={clearCurrentAnnotation}
      >
        CANCEL
      </TertiaryButton>
    </div>
  );
};
